import { NavLink } from "react-router-dom";
import notFoundImg from "../assets/image/404.svg";
//
export default function NotFound() {
  return (
    <>
      <div className="notFoundHanldle">
        <span>
          <img src={notFoundImg} alt="not found" srcSet="" />
        </span>
        <h2>Page Was Not Found! </h2>
        <div className="goBack">
          {" "}
          <span>
            {" "}
            <NavLink to="/home">Go Back to Home Page.</NavLink>
          </span>
        </div>
      </div>
    </>
  );
}
